import React from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'link' | 'danger'
  fullWidth?: boolean
  loading?: boolean
  children: React.ReactNode
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  fullWidth = false,
  loading = false,
  disabled,
  className = '',
  children,
  ...props
}) => {
  const baseClasses =
    'inline-flex justify-center items-center font-medium rounded-md focus:outline-none transition-colors'

  const variantClasses = {
    primary:
      'py-2 px-4 border border-transparent text-sm text-white bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50',
    secondary:
      'py-2 px-4 border border-gray-300 text-sm text-gray-700 bg-white hover:bg-gray-50 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50',
    ghost:
      'p-0 text-gray-500 hover:text-gray-700 focus:ring-0 disabled:opacity-50',
    link: 'p-0 text-sm text-blue-600 hover:text-blue-800 focus:ring-0 disabled:opacity-50',
    danger:
      'py-2 px-4 border border-transparent text-sm text-white bg-red-600 hover:bg-red-700 focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50',
  }

  const widthClass = fullWidth ? 'w-full' : ''

  const classes =
    `${baseClasses} ${variantClasses[variant]} ${widthClass} ${className}`.trim()

  return (
    <button className={classes} disabled={disabled || loading} {...props}>
      {children}
    </button>
  )
}

export default Button
